import { ReactNode } from 'react';

import { cn } from '@/utils/tailwind';

import {
  CELL_PADDING,
  MAX_CELL_HEIGHT,
} from '../../DatasetSessionCompare.utils';
import { DEFAULT_COLUMN_WIDTHS, INPUT_COLUMN_IDX } from '../../constants';
import { isInPlayground } from '../../utils/isInPlayground';

interface InputsCellProps {
  isReferenceInputHidden: boolean;
  isTextTruncated: boolean;
  backgroundStyles: string;
  columnWidthStorage: number[];

  hideFeedback: boolean;
  isDetailExample: boolean;
  inputContent: ReactNode;
  hoverButton: ReactNode;
  exampleButton: ReactNode;
  columnIndex?: number;
}

export function InputsCell({
  isReferenceInputHidden,
  isTextTruncated,
  backgroundStyles,
  columnWidthStorage,

  hideFeedback,
  isDetailExample,
  inputContent,
  hoverButton,
  exampleButton,
  columnIndex,
}: InputsCellProps) {
  const inPlayground = isInPlayground();
  const resolvedColumnIndex = columnIndex ?? INPUT_COLUMN_IDX;
  const width =
    columnWidthStorage[resolvedColumnIndex] ?? DEFAULT_COLUMN_WIDTHS;
  return (
    !isReferenceInputHidden && (
      <td
        className={cn(
          'group relative border-b border-r border-secondary bg-background transition-colors',
          !isTextTruncated && 'align-top',
          backgroundStyles
        )}
        data-column={resolvedColumnIndex}
        style={{
          ...CELL_PADDING(inPlayground ? 'lg' : 'sm'),
          width,
          maxWidth: width,
          minWidth: width,
        }}
      >
        <div
          className={cn(
            'absolute inset-y-0 left-0 w-0.5 border-secondary bg-brand-green-400 opacity-0 transition-opacity',
            isDetailExample && 'opacity-100'
          )}
        />
        <div
          className={cn(
            'flex h-full max-w-full items-center justify-between',
            !isTextTruncated ? 'flex-col items-start gap-2' : 'gap-2'
          )}
        >
          <div
            className={cn(
              'flex w-full overflow-hidden',
              !isTextTruncated && inPlayground && `overflow-y-auto`
            )}
            data-testid="dataset-session-compare-inputs"
            style={{
              maxHeight: !isTextTruncated ? MAX_CELL_HEIGHT : undefined,
            }}
          >
            {inputContent}
          </div>
          {exampleButton && (
            <div
              className={cn(
                'flex items-center gap-1',
                isTextTruncated && hideFeedback ? 'shrink-0' : ''
              )}
            >
              {exampleButton}
            </div>
          )}
        </div>

        {hoverButton}
      </td>
    )
  );
}
